export default "__VITE_ASSET__CNlXLThV__"